import service from '@/services/contabilidad/record'

const getDefaultState = () => ({
  // list: [],
  // record: {},
  records: [],
  logs: []
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_RECORDS: (state, records) => {
    state.records = records
  },
  SET_LOGS: (state, logs) => {
    state.logs = logs
  }
}

export const actions = {
  //resetList: ({ state }) => {
  // state.list = []
  //},
  getRecords: async ({ state, dispatch, rootGetters, commit }, { filter }) => {
    return service.getRecords(rootGetters['facturacion/emisorStore/get_Id'], filter).then(response => {
      commit('SET_RECORDS', response)
    })
  },
  getLogs: async ({ rootGetters, commit }, _id) => {
    return service.getLogs(rootGetters['facturacion/emisorStore/get_Id'], _id).then(response => {
      commit('SET_LOGS', response)

      return response
    })
  },
  update: async ({ rootGetters }, { record, razon }) => {
    return service.update(rootGetters['facturacion/emisorStore/get_Id'], record._id, record.items._id, record.items.cuentaContable, razon)
  }
}

export const getters = {
  getRecords: state => state.records,
}
